import { createSelector } from "@reduxjs/toolkit";
import initialState from "../redux/initialState"
import { RootState } from "types";


export const getFormsState = (state: RootState) => state.formsState || initialState

export const selectformData = createSelector(
    [getFormsState],
    (formsState)=>formsState.formData
)

export const selectIsLoading = createSelector(
    [getFormsState],
    (formsState)=>formsState.loading
)